var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketLaunch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 6.87118C14.2857 5.12762 13.6429 3.45548 12.4987 2.2226C12.2233 1.9258 11.7767 1.9258 11.5013 2.2226C10.3571 3.45548 9.71428 5.12762 9.71428 6.87118V10.6133L8.63166 11.1967C8.24453 11.4053 8 11.8317 8 12.2981V13.6921C8 13.8622 8.12794 14 8.28575 14H15.7143C15.8721 14 16 13.8622 16 13.6921V12.2981C16 11.8317 15.7555 11.4053 15.3683 11.1967L14.2857 10.6133V6.87118Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18H4C2.89543 18 2 17.1046 2 16V5C2 3.89543 2.89543 3 4 3H9.1442C8.53671 4.18195 8.21428 5.51288 8.21428 6.87118V9.71771L7.92007 9.87626C7.01187 10.3657 6.5 11.3216 6.5 12.2981V13.6921C6.5 14.5832 7.19621 15.5 8.28594 15.5H15.7143C16.804 15.5 17.5 14.5832 17.5 13.6921V12.2981C17.5 11.3216 16.9881 10.3657 16.0799 9.87626L15.7857 9.71771V6.87118C15.7857 5.51288 15.4633 4.18195 14.8558 3H20C21.1046 3 22 3.89543 22 5V16C22 17.1046 21.1046 18 20 18H12.75V20.25H15C15.4142 20.25 15.75 20.5858 15.75 21C15.75 21.4142 15.4142 21.75 15 21.75H9C8.58579 21.75 8.25 21.4142 8.25 21C8.25 20.5858 8.58579 20.25 9 20.25H11.25V18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch2);
export default __webpack_public_path__ + "static/media/rocket-launch-2.2d142f00270959a487b30e2c55cf94ca.svg";
export { ForwardRef as ReactComponent };